"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const react_2 = __importDefault(require("react"));
const clockIcon_svg_1 = __importDefault(require("../../../assets/icons/clockIcon.svg"));
const filterIcon_svg_1 = __importDefault(require("../../../assets/icons/filterIcon.svg"));
const mapLegend_svg_1 = __importDefault(require("../../../assets/icons/mapLegend.svg"));
const pinImage_svg_1 = __importDefault(require("../../../assets/icons/pinImage.svg"));
const booleans_1 = require("../../../const/booleans");
const coordinates_1 = require("../../../const/coordinates");
const store_1 = require("../../../store");
const fixedSessionsSelectors_1 = require("../../../store/fixedSessionsSelectors");
const fixedSessionsSlice_1 = require("../../../store/fixedSessionsSlice");
const fixedStreamSelectors_1 = require("../../../store/fixedStreamSelectors");
const fixedStreamSlice_1 = require("../../../store/fixedStreamSlice");
const hooks_1 = require("../../../store/hooks");
const indoorSessionsSelectors_1 = require("../../../store/indoorSessionsSelectors");
const indoorSessionsSlice_1 = require("../../../store/indoorSessionsSlice");
const mapSlice_1 = require("../../../store/mapSlice");
const markersLoadingSlice_1 = require("../../../store/markersLoadingSlice");
const mobileSessionsSelectors_1 = require("../../../store/mobileSessionsSelectors");
const mobileSessionsSlice_1 = require("../../../store/mobileSessionsSlice");
const mobileStreamSelectors_1 = require("../../../store/mobileStreamSelectors");
const mobileStreamSlice_1 = require("../../../store/mobileStreamSlice");
const sensorsSlice_1 = require("../../../store/sensorsSlice");
const sessionFiltersSlice_1 = require("../../../store/sessionFiltersSlice");
const thresholdSlice_1 = require("../../../store/thresholdSlice");
const timelapseSelectors_1 = require("../../../store/timelapseSelectors");
const timelapseSlice_1 = require("../../../store/timelapseSlice");
const filters_1 = require("../../../types/filters");
const timeRange_1 = require("../../../types/timeRange");
const userStates_1 = require("../../../types/userStates");
const cookieManager_1 = require("../../../utils/cookieManager");
const Cookies = __importStar(require("../../../utils/cookies"));
const geocodeAddress_1 = require("../../../utils/geocodeAddress");
const geolocation_1 = require("../../../utils/geolocation");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const scrollEnd_1 = require("../../../utils/scrollEnd");
const cityPersistTimeout_1 = require("../../../utils/cityPersistTimeout");
const extractPrimaryCity_1 = require("../../../utils/extractPrimaryCity");
const trackCityEvent_1 = require("../../../utils/trackCityEvent");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const Loader_1 = require("../../atoms/Loader/Loader");
const SectionButton_1 = require("../../atoms/SectionButton/SectionButton");
const MobileSessionFilters_1 = require("../../molecules/SessionFilters/MobileSessionFilters");
const MobileSessionList_1 = require("../../molecules/SessionsListView/MobileSessionList/MobileSessionList");
const SessionsListView_1 = require("../../molecules/SessionsListView/SessionsListView");
const SessionDetailsModal_1 = require("../../organisms/Modals/SessionDetailsModal");
const TimelapseModal_1 = require("../../organisms/Modals/TimelapseModal");
const ThresholdButton_1 = require("../../organisms/ThresholdConfigurator/ThresholdButtons/ThresholdButton");
const ThresholdConfigurator_1 = require("../../organisms/ThresholdConfigurator/ThresholdConfigurator");
const Legend_1 = require("./Legend/Legend");
const S = __importStar(require("./Map.style"));
const mapStyles_1 = __importDefault(require("./mapUtils/mapStyles"));
const mapStylesZoomedIn_1 = __importDefault(require("./mapUtils/mapStylesZoomedIn"));
const CrowdMapMarkers_1 = require("./Markers/CrowdMapMarkers");
const DormantMarkers_1 = require("./Markers/DormantMarkers");
const FixedMarkers_1 = require("./Markers/FixedMarkers");
const MobileMarkers_1 = require("./Markers/MobileMarkers");
const StreamMarkers_1 = require("./Markers/StreamMarkers");
const TimelapseMarkers_1 = require("./Markers/TimelapseMarkers");
const Map = () => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { boundEast, boundNorth, boundSouth, boundWest, city, removeCityParam, setSearchParams, setUrlParams, currentCenter, currentUserSettings, currentZoom, fetchedSessions, goToUserSettings, isActive, isIndoor, limit, updateLimit, updateOffset, mapTypeId, measurementType, offset, previousCenter, previousUserSettings, previousZoom, revertUserSettingsAndResetIds, sensorName, sessionId, sessionType, streamId, searchParams, tags, timeFrom, timeTo, initialThresholds, unitSymbol, updateFetchedSessions, usernames, } = (0, mapParamsHandler_1.useMapParams)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const isFirstRender = (0, react_1.useRef)(true);
    const isFirstRenderForThresholds = (0, react_1.useRef)(true);
    const lastHandledCityRef = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const isIndoorParameterInUrl = isIndoor === booleans_1.TRUE;
    // State
    const [mapInstance, setMapInstance] = (0, react_1.useState)(null);
    const [pulsatingSessionId, setPulsatingSessionId] = (0, react_1.useState)(null);
    // Selectors
    const defaultThresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectDefaultThresholds);
    const fetchableMobileSessionsCount = (0, hooks_1.useAppSelector)((state) => state.mobileSessions.fetchableSessionsCount);
    const fetchableFixedSessionsCount = (0, hooks_1.useAppSelector)((state) => state.fixedSessions.fetchableSessionsCount);
    const fetchingData = (0, hooks_1.useAppSelector)(mapSlice_1.selectFetchingData);
    (0, react_1.useEffect)(() => () => (0, cityPersistTimeout_1.resetCitySettle)(), []);
    const fixedSessionsType = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectFixedSessionsType);
    const fixedPoints = (0, hooks_1.useAppSelector)((state) => (0, fixedSessionsSelectors_1.selectFixedSessionsPoints)(state, fixedSessionsType));
    const fixedSessionsStatusFulfilled = (0, hooks_1.useAppSelector)(fixedSessionsSelectors_1.selectFixedSessionsStatusFulfilled);
    const selectorsLoading = (0, hooks_1.useAppSelector)(store_1.selectIsLoading);
    const markersLoading = (0, hooks_1.useAppSelector)(markersLoadingSlice_1.selectMarkersLoading);
    const mobilePoints = sessionId
        ? (0, hooks_1.useAppSelector)((0, mobileSessionsSelectors_1.selectMobileSessionPointsBySessionId)(sessionId))
        : (0, hooks_1.useAppSelector)(mobileSessionsSelectors_1.selectMobileSessionsPoints);
    const mobileStreamPoints = (0, hooks_1.useAppSelector)(mobileStreamSelectors_1.selectMobileStreamPoints);
    const realtimeMapUpdates = (0, hooks_1.useAppSelector)((state) => state.realtimeMapUpdates.realtimeMapUpdates);
    const timelapseData = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectTimelapseData);
    const currentTimestamp = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectCurrentTimestamp);
    const isDormant = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectIsDormantSessionsType);
    const tagsToSelect = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectTags);
    const fixedSessionTypeSelected = sessionType === filters_1.SessionTypes.FIXED;
    const selectListSessions = (0, react_1.useMemo)(() => (state) => {
        if (fixedSessionTypeSelected) {
            if (isIndoorParameterInUrl) {
                return (0, indoorSessionsSelectors_1.selectIndoorSessionsList)(isDormant)(state);
            }
            else {
                return (0, fixedSessionsSelectors_1.selectFixedSessionsList)(state, fixedSessionsType);
            }
        }
        else {
            return (0, mobileSessionsSelectors_1.selectMobileSessionsList)(state);
        }
    }, [
        fixedSessionTypeSelected,
        isIndoorParameterInUrl,
        isDormant,
        fixedSessionsType,
    ]);
    const listSessions = (0, hooks_1.useAppSelector)(selectListSessions);
    const fixedStreamData = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedData);
    const memoizedMapStyles = (0, react_1.useMemo)(() => mapStyles_1.default, []);
    // update fixed session type based on the URL)
    (0, react_1.useEffect)(() => {
        if (isActive) {
            if (fixedSessionsType !== sessionFiltersSlice_1.FixedSessionsTypes.ACTIVE) {
                dispatch((0, sessionFiltersSlice_1.setFixedSessionsType)(sessionFiltersSlice_1.FixedSessionsTypes.ACTIVE));
            }
        }
        else {
            if (fixedSessionsType !== sessionFiltersSlice_1.FixedSessionsTypes.DORMANT) {
                dispatch((0, sessionFiltersSlice_1.setFixedSessionsType)(sessionFiltersSlice_1.FixedSessionsTypes.DORMANT));
            }
        }
    }, [isActive, fixedSessionsType, dispatch]);
    // Handle mobile link redirect for fixed sessions
    (0, react_1.useEffect)(() => {
        if (isMobile &&
            currentUserSettings === userStates_1.UserSettings.ModalView &&
            fixedSessionTypeSelected &&
            streamId) {
            const newSearchParams = new URLSearchParams(searchParams.toString());
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousUserSettings, userStates_1.UserSettings.MapView);
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.currentUserSettings, userStates_1.UserSettings.CalendarView);
            navigate(`/fixed_stream?${newSearchParams.toString()}`, {
                replace: true,
            });
        }
    }, [
        isMobile,
        currentUserSettings,
        fixedSessionTypeSelected,
        streamId,
        searchParams,
        navigate,
    ]);
    const fetchableIndoorSessionsCount = listSessions.length;
    const fetchableSessionsCount = (0, react_1.useMemo)(() => {
        return sessionType === filters_1.SessionTypes.FIXED
            ? isIndoorParameterInUrl
                ? fetchableIndoorSessionsCount
                : fetchableFixedSessionsCount
            : fetchableMobileSessionsCount;
    }, [
        fetchableFixedSessionsCount,
        fetchableMobileSessionsCount,
        sessionType,
        fetchableIndoorSessionsCount,
        isIndoorParameterInUrl,
    ]);
    const memoizedTimelapseData = (0, react_1.useMemo)(() => timelapseData, [timelapseData]);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    const preparedUnitSymbol = unitSymbol.replace(/"/g, "");
    const encodedUnitSymbol = encodeURIComponent(preparedUnitSymbol);
    const sensorNamedDecoded = decodeURIComponent(sensorName);
    const tagsDecoded = tags && decodeURIComponent(tags);
    const usernamesDecoded = usernames && decodeURIComponent(usernames);
    const isTimelapseView = currentUserSettings === userStates_1.UserSettings.TimelapseView;
    const isTimelapseDisabled = listSessions.length === 0 || isDormant || isIndoorParameterInUrl;
    const zoomLevel = !Number.isNaN(currentZoom) ? Math.round(currentZoom) : 5;
    const filters = (0, react_1.useMemo)(() => JSON.stringify({
        time_from: timeFrom,
        time_to: timeTo,
        tags: tagsDecoded,
        usernames: usernamesDecoded,
        west: boundWest,
        east: boundEast,
        south: boundSouth,
        north: boundNorth,
        limit: limit,
        offset: offset,
        sensor_name: sensorNamedDecoded.toLowerCase(),
        measurement_type: measurementType,
        unit_symbol: encodedUnitSymbol,
        zoom_level: zoomLevel,
        is_indoor: isIndoorParameterInUrl,
    }), [
        boundEast,
        boundNorth,
        boundSouth,
        boundWest,
        encodedUnitSymbol,
        isIndoorParameterInUrl,
        limit,
        measurementType,
        offset,
        sensorNamedDecoded,
        tagsDecoded,
        timeFrom,
        timeTo,
        usernamesDecoded,
        zoomLevel,
    ]);
    const indoorSessionsFilters = (0, react_1.useMemo)(() => JSON.stringify({
        time_from: timeFrom,
        time_to: timeTo,
        tags: tagsDecoded,
        usernames: usernamesDecoded,
        is_indoor: true,
        sensor_name: sensorNamedDecoded.toLowerCase(),
        measurement_type: measurementType,
        unit_symbol: encodedUnitSymbol,
    }), [
        encodedUnitSymbol,
        measurementType,
        sensorNamedDecoded,
        tagsDecoded,
        timeFrom,
        timeTo,
        usernamesDecoded,
    ]);
    const thresholdFilters = (0, react_1.useMemo)(() => {
        return `${sensorName}?unit_symbol=${encodedUnitSymbol}`;
    }, [sensorName, encodedUnitSymbol]);
    const applyMapStylesBasedOnZoom = (mapInstance, mapStylesZoomedIn, defaultMapStyles) => {
        if (!mapInstance)
            return;
        const zoom = mapInstance.getZoom();
        if (zoom && zoom >= 5.5) {
            mapInstance.setOptions({
                styles: mapStylesZoomedIn,
            });
        }
        else {
            mapInstance.setOptions({
                styles: defaultMapStyles,
            });
        }
    };
    // Effects
    (0, react_1.useEffect)(() => {
        dispatch((0, sensorsSlice_1.fetchSensors)(sessionType));
    }, [sessionType]);
    (0, react_1.useEffect)(() => {
        tagsToSelect.length > 0 && dispatch((0, sessionFiltersSlice_1.resetTags)());
    }, [
        sensorName,
        sessionType,
        isIndoorParameterInUrl,
        encodedUnitSymbol,
        measurementType,
        timeFrom,
        timeTo,
        usernames,
        isActive,
    ]);
    (0, react_1.useEffect)(() => {
        const isFirstLoad = isFirstRender.current;
        // Wait until ?city= has been handled before fetching, so the ad-landing
        // geocode owns the initial bounds.
        if (city !== null &&
            city !== "" &&
            lastHandledCityRef.current !== city)
            return;
        if (isFirstLoad && fetchedSessions > 0 && !fixedSessionTypeSelected) {
            const originalLimit = limit;
            updateLimit(fetchedSessions);
            const updatedFilters = Object.assign(Object.assign({}, JSON.parse(filters)), { limit: fetchedSessions });
            // Save bounds in cookies when fetching sessions (only if preferences are allowed)
            if (cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
                Cookies.set("mapBoundsEast", boundEast.toString());
                Cookies.set("mapBoundsNorth", boundNorth.toString());
                Cookies.set("mapBoundsSouth", boundSouth.toString());
                Cookies.set("mapBoundsWest", boundWest.toString());
            }
            dispatch((0, mobileSessionsSlice_1.fetchMobileSessions)({ filters: JSON.stringify(updatedFilters) }))
                .unwrap()
                .then(() => {
                updateLimit(originalLimit);
                updateFetchedSessions(fetchedSessions);
            });
            isFirstRender.current = false;
        }
        else {
            if (fetchingData || isFirstLoad) {
                // Save bounds in cookies when fetching sessions (only if preferences are allowed)
                if (cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
                    Cookies.set("mapBoundsEast", boundEast.toString());
                    Cookies.set("mapBoundsNorth", boundNorth.toString());
                    Cookies.set("mapBoundsSouth", boundSouth.toString());
                    Cookies.set("mapBoundsWest", boundWest.toString());
                }
                if (fixedSessionTypeSelected) {
                    if (isIndoorParameterInUrl) {
                        if (isActive) {
                            dispatch((0, indoorSessionsSlice_1.fetchActiveIndoorSessions)({ filters: indoorSessionsFilters })).unwrap();
                        }
                        else {
                            dispatch((0, indoorSessionsSlice_1.fetchDormantIndoorSessions)({ filters: indoorSessionsFilters })).unwrap();
                        }
                    }
                    else {
                        if (isActive) {
                            dispatch((0, fixedSessionsSlice_1.fetchActiveFixedSessions)({ filters })).unwrap();
                        }
                        else {
                            dispatch((0, fixedSessionsSlice_1.fetchDormantFixedSessions)({ filters })).unwrap();
                        }
                    }
                }
                else {
                    dispatch((0, mobileSessionsSlice_1.fetchMobileSessions)({ filters }))
                        .unwrap()
                        .then((response) => {
                        updateFetchedSessions(response.sessions.length);
                    });
                }
                isFirstRender.current = false;
            }
        }
        dispatch((0, mapSlice_1.setFetchingData)(false));
    }, [
        fetchingData,
        filters,
        fetchedSessions,
        limit,
        dispatch,
        fixedSessionTypeSelected,
        offset,
        updateFetchedSessions,
    ]);
    (0, react_1.useEffect)(() => {
        if (thresholdFilters) {
            dispatch((0, thresholdSlice_1.fetchThresholds)(thresholdFilters));
        }
    }, [thresholdFilters, dispatch]);
    (0, react_1.useEffect)(() => {
        // Only reset thresholds if this is not the first render and defaultThresholds are loaded
        if (!isFirstRenderForThresholds.current &&
            defaultThresholds &&
            defaultThresholds.max !== 0) {
            dispatch((0, thresholdSlice_1.resetUserThresholds)());
        }
        // Only update the ref if defaultThresholds has been loaded
        if (defaultThresholds && defaultThresholds.max !== 0) {
            isFirstRenderForThresholds.current = false;
        }
    }, [defaultThresholds, dispatch]);
    (0, react_1.useEffect)(() => {
        // Only set user threshold values on first render and if initialThresholds are valid
        if (isFirstRenderForThresholds.current &&
            initialThresholds &&
            initialThresholds.max !== 0) {
            dispatch((0, thresholdSlice_1.setUserThresholdValues)(initialThresholds));
        }
        // Update the ref if initialThresholds is not yet loaded
        if (initialThresholds && initialThresholds.max === 0) {
            isFirstRenderForThresholds.current = false;
        }
    }, [initialThresholds, dispatch]);
    (0, react_1.useEffect)(() => {
        if (currentUserSettings !== userStates_1.UserSettings.ModalView) {
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.sessionId, "");
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.streamId, "");
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.isActive, isActive.toString());
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.sessionType, sessionType);
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.boundEast, boundEast.toString());
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.boundNorth, boundNorth.toString());
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.boundSouth, boundSouth.toString());
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.boundWest, boundWest.toString());
            navigate(`?${newSearchParams.toString()}`);
        }
        !isFirstRender.current && setPreviousZoomOnTheMap();
        isMobile && setPreviousZoomInTheURL();
        isFirstRender.current = false;
    }, [currentUserSettings]);
    (0, react_1.useEffect)(() => {
        if (previousUserSettings === userStates_1.UserSettings.CalendarView) {
            const intervalId = setInterval(() => {
                setPreviousZoomOnTheMap();
                clearInterval(intervalId);
            }, 10);
            return () => clearInterval(intervalId);
        }
    }, [mapInstance, previousUserSettings]);
    (0, react_1.useEffect)(() => {
        if (streamId &&
            currentUserSettings === userStates_1.UserSettings.ModalView &&
            !fixedStreamData.measurements.length) {
            fixedSessionTypeSelected
                ? dispatch((0, fixedStreamSlice_1.fetchFixedStreamById)({ id: streamId, sensorName: sensorNamedDecoded }))
                : dispatch((0, mobileStreamSlice_1.fetchMobileStreamById)(streamId));
        }
    }, [
        streamId,
        currentUserSettings,
        fixedSessionTypeSelected,
        previousUserSettings,
        isIndoorParameterInUrl,
    ]);
    (0, react_1.useEffect)(() => {
        if (realtimeMapUpdates) {
            dispatch((0, fixedSessionsSlice_1.cleanSessions)());
            dispatch((0, mapSlice_1.setFetchingData)(true));
        }
    }, [
        boundEast,
        boundNorth,
        boundSouth,
        boundWest,
        realtimeMapUpdates,
        dispatch,
    ]);
    (0, react_1.useEffect)(() => {
        if (currentUserSettings === userStates_1.UserSettings.TimelapseView) {
            const storedBounds = {
                east: Number.parseFloat(Cookies.get("mapBoundsEast") || boundEast.toString()),
                north: Number.parseFloat(Cookies.get("mapBoundsNorth") || boundNorth.toString()),
                south: Number.parseFloat(Cookies.get("mapBoundsSouth") || boundSouth.toString()),
                west: Number.parseFloat(Cookies.get("mapBoundsWest") || boundWest.toString()),
            };
            const timelapseFilters = Object.assign(Object.assign({}, JSON.parse(filters)), { west: storedBounds.west, east: storedBounds.east, north: storedBounds.north, south: storedBounds.south });
            dispatch((0, timelapseSlice_1.fetchTimelapseData)({ filters: JSON.stringify(timelapseFilters) }));
        }
    }, [currentUserSettings, fixedPoints]);
    (0, react_1.useEffect)(() => {
        if (!mapInstance || !city || lastHandledCityRef.current === city)
            return;
        // A selected session owns the zoom: don't let the ad-landing city
        // geocode fit-bounds the map back out to the whole city (e.g. a shared
        // permalink that still carries ?city= alongside sessionId/streamId).
        if (sessionId || streamId) {
            lastHandledCityRef.current = city;
            return;
        }
        // In-app search already handled this city; skip the ad-landing path so
        // we don't re-geocode or double-fire GA4.
        if ((0, cityPersistTimeout_1.isCitySettlePending)()) {
            lastHandledCityRef.current = city;
            return;
        }
        lastHandledCityRef.current = city;
        dispatch((0, mapSlice_1.setFetchingData)(false));
        (0, cityPersistTimeout_1.armCitySettle)();
        // URLSearchParams already decoded `city`; a second decode crashes on stray % sequences.
        const cityRaw = city;
        (0, geocodeAddress_1.geocodeAddress)(cityRaw).then((result) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            let mapWillMove = false;
            if (result) {
                if (result.bounds) {
                    mapInstance.fitBounds(result.bounds);
                }
                else {
                    mapInstance.panTo({ lat: result.lat, lng: result.lng });
                    mapInstance.setZoom(result.zoom);
                }
                mapWillMove = true;
                (0, trackCityEvent_1.trackCityEvent)({
                    city: (0, extractPrimaryCity_1.extractPrimaryCity)((_a = result.resolvedName) !== null && _a !== void 0 ? _a : cityRaw),
                    cityRaw,
                    source: "ad_landing",
                    resolutionStatus: "success",
                    lat: result.lat,
                    lng: result.lng,
                    sessionType,
                });
            }
            else {
                const geo = yield (0, geolocation_1.getBrowserLocation)(mapInstance, setUrlParams);
                mapWillMove = !!geo;
                (0, trackCityEvent_1.trackCityEvent)({
                    city: (0, extractPrimaryCity_1.extractPrimaryCity)(cityRaw),
                    cityRaw,
                    source: "ad_landing_fallback",
                    resolutionStatus: geo ? "fallback_geo" : "fallback_default",
                    sessionType,
                });
            }
            const finalize = () => {
                if (result === null || result === void 0 ? void 0 : result.bounds) {
                    const sw = result.bounds.getSouthWest();
                    const ne = result.bounds.getNorthEast();
                    setSearchParams((prev) => {
                        const np = new URLSearchParams(prev);
                        np.set(mapParamsHandler_1.UrlParamsTypes.boundEast, ne.lng().toString());
                        np.set(mapParamsHandler_1.UrlParamsTypes.boundNorth, ne.lat().toString());
                        np.set(mapParamsHandler_1.UrlParamsTypes.boundSouth, sw.lat().toString());
                        np.set(mapParamsHandler_1.UrlParamsTypes.boundWest, sw.lng().toString());
                        np.set(mapParamsHandler_1.UrlParamsTypes.currentCenter, JSON.stringify({ lat: result.lat, lng: result.lng }));
                        np.set(mapParamsHandler_1.UrlParamsTypes.currentZoom, result.zoom.toString());
                        return np;
                    }, { replace: true });
                }
                else {
                    removeCityParam();
                }
                dispatch((0, mapSlice_1.setFetchingData)(true));
            };
            if (mapWillMove) {
                google.maps.event.addListenerOnce(mapInstance, "idle", finalize);
            }
            else {
                finalize();
            }
        }));
    }, [
        mapInstance,
        city,
        sessionId,
        streamId,
        sessionType,
        setUrlParams,
        setSearchParams,
        removeCityParam,
        dispatch,
    ]);
    const handleScrollEnd = (0, scrollEnd_1.useHandleScrollEnd)(offset, listSessions, updateOffset, updateFetchedSessions, filters, fetchableMobileSessionsCount, fetchableFixedSessionsCount, isDormant);
    const handleMapIdle = (0, react_1.useCallback)((event) => {
        var _a;
        const map = event.map;
        if (!mapInstance) {
            setMapInstance(map);
            map.setOptions({
                clickableIcons: false,
            });
        }
        applyMapStylesBasedOnZoom(map, mapStylesZoomedIn_1.default, memoizedMapStyles);
        if (isFirstRender.current) {
            if (currentUserSettings === userStates_1.UserSettings.MapView) {
                newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.sessionType, sessionType);
                newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.isActive, booleans_1.TRUE);
                map.setCenter(currentCenter);
                map.setZoom(currentZoom);
            }
            isFirstRender.current = false;
        }
        else {
            if ([userStates_1.UserSettings.MapView, userStates_1.UserSettings.CrowdMapView].includes(currentUserSettings)) {
                const currentCenter = JSON.stringify(((_a = map.getCenter()) === null || _a === void 0 ? void 0 : _a.toJSON()) || previousCenter);
                const currentZoom = (map.getZoom() || previousZoom).toString();
                const bounds = map === null || map === void 0 ? void 0 : map.getBounds();
                if (!bounds) {
                    return;
                }
                const north = bounds.getNorthEast().lat();
                const south = bounds.getSouthWest().lat();
                const east = bounds.getNorthEast().lng();
                const west = bounds.getSouthWest().lng();
                // Read URL fresh: `searchParams` from the render closure can lag
                // behind a setSearchParams that fired just before `idle` (e.g.
                // LocationSearch writing `city=` then calling fitBounds). Using
                // the stale closure would clobber that write on navigate.
                const np = new URLSearchParams(window.location.search);
                // Programmatic settle consumes one pending count; a user-driven
                // idle with `city=` still in the URL strips it.
                if ((0, cityPersistTimeout_1.isCitySettlePending)()) {
                    (0, cityPersistTimeout_1.disarmCitySettle)();
                }
                else if (np.get(mapParamsHandler_1.UrlParamsTypes.city)) {
                    np.delete(mapParamsHandler_1.UrlParamsTypes.city);
                }
                np.set(mapParamsHandler_1.UrlParamsTypes.boundEast, east.toString());
                np.set(mapParamsHandler_1.UrlParamsTypes.boundNorth, north.toString());
                np.set(mapParamsHandler_1.UrlParamsTypes.boundSouth, south.toString());
                np.set(mapParamsHandler_1.UrlParamsTypes.boundWest, west.toString());
                np.set(mapParamsHandler_1.UrlParamsTypes.currentCenter, currentCenter);
                np.set(mapParamsHandler_1.UrlParamsTypes.currentZoom, currentZoom);
                if (cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
                    Cookies.set(mapParamsHandler_1.UrlParamsTypes.boundEast, east.toString());
                    Cookies.set(mapParamsHandler_1.UrlParamsTypes.boundNorth, north.toString());
                    Cookies.set(mapParamsHandler_1.UrlParamsTypes.boundSouth, south.toString());
                    Cookies.set(mapParamsHandler_1.UrlParamsTypes.boundWest, west.toString());
                    Cookies.set(mapParamsHandler_1.UrlParamsTypes.currentCenter, currentCenter);
                    Cookies.set(mapParamsHandler_1.UrlParamsTypes.currentZoom, currentZoom);
                }
                navigate(`?${np.toString()}`);
            }
        }
    }, [currentUserSettings, mapInstance, searchParams, dispatch]);
    // ref to currentUserSettings to get the current value from URL
    const currentUserSettingsRef = (0, react_1.useRef)(currentUserSettings);
    (0, react_1.useEffect)(() => {
        currentUserSettingsRef.current = currentUserSettings;
    }, [currentUserSettings]);
    const handleMarkerClick = (selectedStreamId, id) => {
        if (currentUserSettings !== userStates_1.UserSettings.SessionListView) {
            setPreviousZoomInTheURL();
        }
        if (selectedStreamId) {
            if (fixedSessionTypeSelected) {
                dispatch((0, fixedStreamSlice_1.setLastSelectedTimeRange)(timeRange_1.FixedTimeRange.Day));
                dispatch((0, fixedStreamSlice_1.fetchFixedStreamById)({ id: selectedStreamId, sensorName: sensorNamedDecoded }));
            }
            else {
                dispatch((0, mobileStreamSlice_1.fetchMobileStreamById)(selectedStreamId));
            }
        }
        // Drop the ad-landing city param so the session permalink we share/reload
        // zooms to the session, not back out to the whole city.
        newSearchParams.delete(mapParamsHandler_1.UrlParamsTypes.city);
        if (isMobile) {
            if (fixedSessionTypeSelected) {
                newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousUserSettings, currentUserSettingsRef.current);
                newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.currentUserSettings, userStates_1.UserSettings.CalendarView);
                newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.sessionId, (id === null || id === void 0 ? void 0 : id.toString()) || "");
                newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.streamId, (selectedStreamId === null || selectedStreamId === void 0 ? void 0 : selectedStreamId.toString()) || "");
                navigate(`/fixed_stream?${newSearchParams.toString()}`, {
                    replace: true,
                });
                return;
            }
        }
        if (!streamId) {
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.sessionId, (id === null || id === void 0 ? void 0 : id.toString()) || "");
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.streamId, (selectedStreamId === null || selectedStreamId === void 0 ? void 0 : selectedStreamId.toString()) || "");
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousUserSettings, currentUserSettingsRef.current);
            newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.currentUserSettings, userStates_1.UserSettings.ModalView);
            navigate(`?${newSearchParams.toString()}`);
        }
        if (streamId) {
            revertUserSettingsAndResetIds();
            fixedSessionTypeSelected
                ? dispatch((0, fixedStreamSlice_1.resetFixedStreamState)())
                : dispatch((0, mobileStreamSlice_1.resetMobileStreamState)());
        }
    };
    const setPreviousZoomOnTheMap = () => {
        if ([userStates_1.UserSettings.MapView, userStates_1.UserSettings.CrowdMapView].includes(currentUserSettings) &&
            ![
                userStates_1.UserSettings.MapView,
                userStates_1.UserSettings.MapLegendView,
                userStates_1.UserSettings.FiltersView,
                userStates_1.UserSettings.CrowdMapView,
                userStates_1.UserSettings.TimelapseView,
            ].includes(previousUserSettings)) {
            if (mapInstance) {
                mapInstance.setCenter(previousCenter);
                mapInstance.setZoom(previousZoom);
            }
        }
    };
    const setPreviousZoomInTheURL = () => {
        var _a;
        const desktopCondition = !isMobile &&
            currentUserSettings !== userStates_1.UserSettings.ModalView &&
            previousUserSettings !== userStates_1.UserSettings.CalendarView;
        const mobileCondition = isMobile && currentUserSettings === userStates_1.UserSettings.MapView;
        const mobileConditionForSessionList = isMobile &&
            currentUserSettings === userStates_1.UserSettings.SessionListView &&
            previousUserSettings === userStates_1.UserSettings.MapView;
        if (mapInstance) {
            if (desktopCondition ||
                mobileCondition ||
                mobileConditionForSessionList) {
                const newCenter = (_a = mapInstance.getCenter()) === null || _a === void 0 ? void 0 : _a.toJSON();
                if (newCenter !== previousCenter) {
                    newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousCenter, JSON.stringify(newCenter || currentCenter));
                    if (cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
                        Cookies.set(mapParamsHandler_1.UrlParamsTypes.previousCenter, JSON.stringify(newCenter || currentCenter));
                    }
                }
                const newZoom = mapInstance === null || mapInstance === void 0 ? void 0 : mapInstance.getZoom();
                if (newZoom !== previousZoom) {
                    newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousZoom, (newZoom === null || newZoom === void 0 ? void 0 : newZoom.toString()) || currentZoom.toString());
                    if (cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
                        Cookies.set(mapParamsHandler_1.UrlParamsTypes.previousZoom, (newZoom === null || newZoom === void 0 ? void 0 : newZoom.toString()) || currentZoom.toString());
                    }
                }
                navigate(`?${newSearchParams.toString()}`);
            }
        }
    };
    const handleMapZoomStyles = (0, react_1.useCallback)(() => {
        if (mapInstance) {
            applyMapStylesBasedOnZoom(mapInstance, mapStylesZoomedIn_1.default, memoizedMapStyles);
        }
    }, [mapInstance, memoizedMapStyles]);
    const handleZoomChanged = () => {
        if (mapInstance) {
            handleMapZoomStyles();
        }
    };
    const openFilters = () => {
        goToUserSettings(userStates_1.UserSettings.FiltersView);
    };
    const openTimelapse = () => {
        // Clear existing timelapse markers before switching views
        dispatch((0, timelapseSlice_1.setCurrentTimestamp)(""));
        // Add a small delay to ensure markers are cleared before view changes
        setTimeout(() => {
            goToUserSettings(currentUserSettings === userStates_1.UserSettings.TimelapseView
                ? previousUserSettings
                : userStates_1.UserSettings.TimelapseView);
        }, 0);
    };
    const isTimelapseLoading = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectTimelapseIsLoading);
    const renderTimelapseMarkers = () => {
        if (currentUserSettings === userStates_1.UserSettings.TimelapseView &&
            currentTimestamp &&
            memoizedTimelapseData[currentTimestamp] &&
            !isTimelapseLoading) {
            return (react_2.default.createElement(TimelapseMarkers_1.TimelapseMarkers, { sessions: memoizedTimelapseData[currentTimestamp] }));
        }
        return null;
    };
    const mapSessions = (session) => ({
        id: session.id,
        sessionName: session.title,
        sensorName: session.sensorName,
        averageValue: session.averageValue,
        startTime: session.startTime,
        endTime: session.endTime,
        streamId: session.streamId,
    });
    return (react_2.default.createElement(react_2.default.Fragment, null,
        (selectorsLoading || markersLoading) && (react_2.default.createElement(S.LoaderOverlay, null,
            react_2.default.createElement(Loader_1.Loader, null))),
        isIndoorParameterInUrl && (react_2.default.createElement(S.IndoorOvelay, null,
            react_2.default.createElement(S.IndoorOverlayInfo, { "$isMobile": isMobile },
                react_2.default.createElement("h1", null, t("filters.indoorMapOverlay"))))),
        react_2.default.createElement(react_google_maps_1.Map, { mapTypeId: mapTypeId, defaultCenter: currentCenter, defaultZoom: currentZoom, gestureHandling: "greedy", disableDefaultUI: true, scaleControl: true, style: S.ContainerStyle, onIdle: handleMapIdle, minZoom: coordinates_1.MIN_ZOOM, isFractionalZoomEnabled: true, styles: memoizedMapStyles, onZoomChanged: handleZoomChanged, tilt: 0, reuseMaps: true },
            fixedSessionsStatusFulfilled &&
                fixedSessionTypeSelected &&
                !isActive &&
                !isIndoorParameterInUrl && (react_2.default.createElement(DormantMarkers_1.DormantMarkers, { sessions: fixedPoints, onMarkerClick: handleMarkerClick, selectedStreamId: streamId, pulsatingSessionId: pulsatingSessionId })),
            isTimelapseView
                ? renderTimelapseMarkers()
                : fixedSessionsStatusFulfilled &&
                    fixedSessionTypeSelected &&
                    !isIndoorParameterInUrl &&
                    isActive && (react_2.default.createElement(FixedMarkers_1.FixedMarkers, { sessions: fixedPoints, onMarkerClick: handleMarkerClick, selectedStreamId: streamId, pulsatingSessionId: pulsatingSessionId })),
            !fixedSessionTypeSelected &&
                ([userStates_1.UserSettings.CrowdMapView].includes(currentUserSettings) ||
                    ([userStates_1.UserSettings.CrowdMapView].includes(previousUserSettings) &&
                        [userStates_1.UserSettings.MapLegendView].includes(currentUserSettings)) ? (react_2.default.createElement(CrowdMapMarkers_1.CrowdMapMarkers, { pulsatingSessionId: pulsatingSessionId, sessions: mobilePoints })) : (react_2.default.createElement(MobileMarkers_1.MobileMarkers, { sessions: mobilePoints, onMarkerClick: handleMarkerClick, selectedStreamId: streamId, pulsatingSessionId: pulsatingSessionId }))),
            streamId && !fixedSessionTypeSelected && (react_2.default.createElement(StreamMarkers_1.StreamMarkers, { sessions: mobileStreamPoints, unitSymbol: unitSymbol }))),
        (!isMobile ||
            (isMobile && currentUserSettings === userStates_1.UserSettings.ModalView)) && (react_2.default.createElement(S.ThresholdContainer, null,
            react_2.default.createElement(ThresholdConfigurator_1.ThresholdsConfigurator, { resetButtonVariant: ThresholdButton_1.ThresholdButtonVariant.IconOnly, isMobileOldStyle: isMobile && currentUserSettings === userStates_1.UserSettings.ModalView }))),
        currentUserSettings === userStates_1.UserSettings.ModalView && (react_2.default.createElement(SessionDetailsModal_1.SessionDetailsModal, { onClose: () => {
                revertUserSettingsAndResetIds();
                fixedSessionTypeSelected
                    ? dispatch((0, fixedStreamSlice_1.resetFixedStreamState)())
                    : dispatch((0, mobileStreamSlice_1.resetMobileStreamState)());
            }, sessionType: sessionType, streamId: streamId })),
        currentUserSettings === userStates_1.UserSettings.TimelapseView && (react_2.default.createElement(TimelapseModal_1.TimelapseComponent, { onClose: () => {
                goToUserSettings(previousUserSettings);
            } })),
        react_2.default.createElement(S.MobileContainer, null,
            currentUserSettings !== userStates_1.UserSettings.ModalView &&
                currentUserSettings !== userStates_1.UserSettings.FiltersView && (react_2.default.createElement(S.MobileButtons, { "$isTimelapseView": isTimelapseView },
                react_2.default.createElement(SectionButton_1.SectionButton, { title: t("map.listSessions"), image: pinImage_svg_1.default, alt: t("map.altListSessions"), onClick: () => goToUserSettings(userStates_1.UserSettings.SessionListView), isNotTimelapseButton: isTimelapseView, isActive: currentUserSettings === userStates_1.UserSettings.SessionListView }),
                react_2.default.createElement(SectionButton_1.SectionButton, { title: t("map.legendTile"), image: mapLegend_svg_1.default, alt: t("map.altlegendTile"), onClick: () => goToUserSettings(userStates_1.UserSettings.MapLegendView), isNotTimelapseButton: isTimelapseView, isActive: currentUserSettings === userStates_1.UserSettings.MapLegendView }),
                fixedSessionTypeSelected && (react_2.default.createElement(SectionButton_1.SectionButton, { title: t("map.timelapsTile"), image: clockIcon_svg_1.default, alt: t("map.altTimelapstile"), onClick: openTimelapse, isNotTimelapseButton: false, isActive: currentUserSettings === userStates_1.UserSettings.TimelapseView, isDisabled: isTimelapseDisabled })),
                react_2.default.createElement(SectionButton_1.SectionButton, { title: t("filters.filters"), image: filterIcon_svg_1.default, alt: t("filters.altFiltersIcon"), onClick: openFilters, isNotTimelapseButton: false }))),
            currentUserSettings === userStates_1.UserSettings.MapLegendView && (react_2.default.createElement(Legend_1.Legend, { onClose: () => goToUserSettings(previousUserSettings) })),
            currentUserSettings === userStates_1.UserSettings.SessionListView && isMobile && (react_2.default.createElement(MobileSessionList_1.MobileSessionList, { sessions: listSessions.map(mapSessions), onCellClick: (id, streamId) => {
                    handleMarkerClick(streamId, id);
                }, onClose: () => [userStates_1.UserSettings.CrowdMapView].includes(previousUserSettings)
                    ? goToUserSettings(userStates_1.UserSettings.CrowdMapView)
                    : goToUserSettings(userStates_1.UserSettings.MapView), onScrollEnd: handleScrollEnd, fetchableSessionsCount: fetchableSessionsCount, isIndoor: isIndoorParameterInUrl, isDormant: isDormant })),
            currentUserSettings === userStates_1.UserSettings.FiltersView && (react_2.default.createElement(MobileSessionFilters_1.MobileSessionFilters, { onClose: () => [userStates_1.UserSettings.CrowdMapView].includes(previousUserSettings)
                    ? goToUserSettings(userStates_1.UserSettings.CrowdMapView)
                    : goToUserSettings(userStates_1.UserSettings.MapView), fetchableSessionsCount: fetchableSessionsCount }))),
        [userStates_1.UserSettings.MapView, userStates_1.UserSettings.CrowdMapView].includes(currentUserSettings) &&
            !isMobile && (react_2.default.createElement(S.DesktopContainer, { "data-testid": "desktop-session-list" },
            react_2.default.createElement(SessionsListView_1.SessionsListView, { sessions: listSessions.map(mapSessions), sessionType: sessionType, sensorName: sensorNamedDecoded, onCellClick: (id, streamId) => {
                    setPulsatingSessionId(null);
                    handleMarkerClick(streamId, id);
                }, onCellMouseEnter: (id) => {
                    setPulsatingSessionId(id);
                }, onCellMouseLeave: () => {
                    setPulsatingSessionId(null);
                }, onScrollEnd: handleScrollEnd, fetchableSessionsCount: fetchableSessionsCount, isIndoor: isIndoorParameterInUrl, isDormant: isDormant })))));
};
exports.Map = Map;
